import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(window.matchMedia('(prefers-color-scheme: dark)').matches)

  const toggleTheme = () => {
    isDark.value = !isDark.value
    updateTheme()
  }

  const updateTheme = () => {
    document.documentElement.setAttribute('data-theme', isDark.value ? 'dark' : 'light')
  }

  // Initialize theme on store creation
  updateTheme()

  return {
    isDark,
    toggleTheme
  }
}, {
  persist: true
})
